/**
 * 正規化ユーティリティ
 * 文字列の正規化処理を統一管理
 */

(function() {
  'use strict';

  /**
   * 文字列を正規化（全角/半角、括弧の統一）
   * @param {string} str - 正規化する文字列
   * @returns {string} - 正規化された文字列
   */
  function normalizeString(str) {
    if (!str || typeof str !== 'string') return str;
    return str
      .replace(/（/g, '(')
      .replace(/）/g, ')')
      .replace(/／/g, '/')
      .replace(/　/g, ' ')
      .replace(/\s+/g, ' ')
      .trim();
  }

  /**
   * 2つの文字列を正規化して比較
   * @param {string} str1 - 比較する文字列1
   * @param {string} str2 - 比較する文字列2
   * @returns {boolean} - 正規化後に等しいかどうか
   */
  function normalizeEquals(str1, str2) {
    return normalizeString(str1) === normalizeString(str2);
  }

  /**
   * 配列内で正規化マッチする要素を検索
   * @param {string} target - 検索対象の文字列
   * @param {Array<string>} array - 検索する配列
   * @returns {string|null} - マッチした要素（元の形式）、見つからない場合はnull
   */
  function findNormalizedMatch(target, array) {
    if (!target || !Array.isArray(array)) return null;
    
    const normalizedTarget = normalizeString(target);
    for (const item of array) {
      if (normalizeString(item) === normalizedTarget) {
        return item;
      }
    }
    return null;
  }

  /**
   * variation codeを正規化
   * @param {string} code - variation code
   * @returns {string} - 正規化されたvariation code
   */
  function normalizeVariationCode(code) {
    if (!code || typeof code !== 'string') return code;
    return normalizeString(code);
  }

  // グローバルに公開
  window.normalizeString = normalizeString;
  window.normalizeEquals = normalizeEquals;
  window.findNormalizedMatch = findNormalizedMatch;
  window.normalizeVariationCode = normalizeVariationCode;

})();

